"use client";

import React, { useEffect, useId, useRef, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { useOutsideClick } from "../UI/use-outside-click";
import { PrjCards } from "./PrjCards";
import { useMediaQuery } from "../../Constants/useMediaQuery";
export function ExpandableCardDemo() {
  const [active, setActive] = useState(null);
  const id = useId();
  const ref = useRef(null);
  useOutsideClick(ref, () => setActive(null));
  useEffect(() => {
    if (active) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [active]);
  return (
    <>
      <AnimatePresence>
        {active && typeof active === "object" && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/20  h-full w-full z-10 "
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {active && typeof active === "object" ? (
          <div className="fixed    px-5 ssm:px-0  inset-0 w-full grid place-items-center z-[100] top-6 ssmm:top-20  ssm:top-28 lg:top-24">
            <motion.button
              key={`button-${active.title}-${id}`}
              layout
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
                transition: {
                  duration: 0.05,
                },
              }}
              className="flex absolute  top-24 ssmm:top-10 ssm:-top-2 md:-top-2 right-2 lg:hidden items-center justify-center bg-white rounded-sm h-6 w-6"
              onClick={() => setActive(null)}
            >
              <CloseIcon />
            </motion.button>

            <motion.div
              layoutId={`card-${active.title}-${id}`}
              ref={ref}
              className="
        w-full 
        rounded-md
        max-w-[600px] 
        md:max-w-[800px] 
        lg:max-w-[900px]
     h-[600px]
  ssmm:h-[700px]
  ssm:h-[800px]
  md:h-auto
  md:max-h-[900px]
        flex flex-col 
        bg-white 
        text-black
        sm:rounded-lg 
        overflow-hidden
      "
            >
              <motion.div
                layoutId={`image-${active.title}-${id}`}
                className="w-full flex justify-center bg-white p-4"
              >
                <img
                  src={active.src}
                  alt={active.title}
                  className="
            w-full 
            h-auto 
            max-h-[60vh]  
            object-contain md:object-cover rounded-md
          "
                />
              </motion.div>

              <div>
                <div className="flex justify-between items-start p-4">
                  <motion.h3
                    layoutId={`title-${active.title}-${id}`}
                    className="text-2xl font-Mtavruli text-black "
                  >
                    {active.title}
                  </motion.h3>
                </div>

                <div className=" pt-0 ssmm:pt-2 relative px-4">
                  <motion.div
                    layout
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="
              font-ArialGeo 
              text-md
             ssmm:text-lg
               pb-2 
             ssmm:pb-10 
              flex flex-col 
              gap-4 
              overflow-auto 
              text-gray-700
              [scrollbar-width:none]
              [-ms-overflow-style:none]
            "
                  >
                    {typeof active.content === "function"
                      ? active.content()
                      : active.content}
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        ) : null}
      </AnimatePresence>
      <motion.div
      // initial={{ opacity: 0, scale: 0.99, filter: "blur(20px)" }}
      // whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
      // transition={{
      //   duration: 0.9,
      //   ease: [0.25, 0.1, 0.25, 1],
      // }}
      // viewport={{
      //   once: true,
      //   amount: 0.3,
      // }}
      >
        <div className="w-full bg-gradient-to-b from-[#000000fb]     via-[#1d1d1dfb] to-[#000000fb] py-24 px-4 ssm:px-5 smm:px-8 md:px-10 clg:px-16   cxl:px-12 -z-50">
          {/* <motion.div
            initial={{ opacity: 0, scale: 0.9, filter: "blur(20px)" }}
            whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{
              duration: 0.9,
              delay: 0.1,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            viewport={{ once: false, amount: 0.4 }}
            className="w-full"
          > */}
          <div className="mx-auto w-full max-w-[1500px] z-50">
            <div className=" mb-6 ssxx:mb-8 smm:mb-16 max-w-[900px]">
              <h1 className="text-3xl xsxm:text-4xl   cxl:text-5xl text-white font-Mtavruli">
                ჩვენი სერვისები, რას გთავაზობთ?
              </h1>
              <div className="mt-4 pl-1 text-sm cxl:text-lg text-gray-100 font-ArialGeo leading-5">
                <p>
                  ჩვენ გთავაზობთ სრულყოფილ გადაწყვეტილებებს ბრენდირებისა და
                  ტექსტილის წარმოების სფეროში — იდეიდან საბოლოო პროდუქტამდე.
                </p>

                <p className="mt-4">
                  ჩვენი გუნდი უზრუნველყოფს მაღალი ხარისხის შედეგს, თანამედროვე
                  ტექნოლოგიებსა და ინდივიდუალურ მიდგომას თითოეული პროექტის
                  მიმართ.
                </p>
              </div>
            </div>

            {/* Cards */}
            <ul className="mx-auto grid px-0 ssm:px-2 sm:px-6 mmd:px-8 lg:px-12 clg:px-20 xl:px-4 w-full max-w-[1100px] cxxl:max-w-[1200px] cxl:max-w-[1500px] grid-cols-1  xl:grid-cols-3 gap-8">
              {PrjCards.map((card) => (
                <motion.li
                  key={card.title}
                  layoutId={`card-${card.title}-${id}`}
                  onClick={() => setActive(card)}
                  className="list-none cursor-pointer"
                >
                  <div className="flex h-full flex-col rounded-2xl bg-[#fffafa]     p-6 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl">
                    <div className="space-y-5">
                      <button className=" text-4xl cxl:text-5xl">
                        {card.icon}
                      </button>

                      <h2 className=" text-2xl font-Mtavruli">{card.title}</h2>

                      <div className=" hidden sfm:block text-sm ssm:text-md cxl:text-lg font-ArialGeo">
                        {card.content()}
                      </div>
                    </div>

                    <div className="mt-auto py-5 sfm:py-0  xxl:py-8 flex justify-center">
                      <motion.div
                        layoutId={`image-${card.title}-${id}`}
                        className="w-full "
                      >
                        <img
                          src={card.src}
                          alt={card.title}
                          className=" h-[200px] ssxx:h-[250px] ssmm:h-[300px] ssm:h-[350px]  sfm:h-[400px] w-full rounded-xl object-cover"
                        />
                      </motion.div>
                    </div>
                  </div>
                </motion.li>
              ))}
            </ul>
          </div>
          {/* </motion.div> */}
        </div>
      </motion.div>
    </>
  );
}

export const CloseIcon = () => {
  return (
    <motion.svg
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.05,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4 text-black"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M18 6l-12 12" />
      <path d="M6 6l12 12" />
    </motion.svg>
  );
};
